import React, { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import ArrowBackWhiteIcon from '../../assets/images/arrow_back_icon.svg?react';
import { useTranslation } from '../../i18n/useTranslation';

const DocumentBackButton: React.FC = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const handleBack = useCallback(() => {
    if ((window.history.state?.idx ?? 0) > 0) {
      navigate(-1);
      return;
    }
    // Opened in a new tab (e.g. from the registration form): try to close it, otherwise go home.
    window.close();
    navigate('/', { replace: true });
  }, [navigate]);

  return (
    <button
      className='absolute top-8 left-5 cursor-pointer w-6 h-6 flex items-center justify-center'
      onClick={handleBack}
      aria-label={t('common.button.back')}
    >
      <ArrowBackWhiteIcon className='w-4.25 h-auto'/>
    </button>
  );
};

export default DocumentBackButton;
